"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var OhsoLogo = function OhsoLogo(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "170.1px",
    height: "170.1px",
    viewBox: "0 0 170.1 170.1"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M83.1,94.2c0,2.2,1.7,3.9,3.9,3.9c2.1,0,3.9-1.8,3.9-3.9c0-2.1-1.7-3.9-3.9-3.9C84.9,90.4,83.1,92.1,83.1,94.2 M44.9,85c0,4.4-2.9,7.4-7.1,7.4s-7.1-3-7.1-7.4c0-4.4,2.9-7.4,7.1-7.4S44.9,80.7,44.9,85 M51.2,85c0-7.6-5.6-13.2-13.4-13.2 c-7.8,0-13.4,5.6-13.4,13.2c0,7.6,5.6,13.2,13.4,13.2C45.6,98.2,51.2,92.6,51.2,85 M71.5,97.7h6.1V72.3h-6.1v9.8H60.8v-9.8h-6.1 v25.4h6.1v-10h10.7V97.7z M87,85.4c0.1,0,4.9-6.8,4.9-9.2c0-2.4-2.2-4.4-4.9-4.4c-2.7,0-4.9,1.9-4.9,4.4 C82.2,78.7,86.9,85.4,87,85.4 M102.2,79.7c0-1.5,1.7-2.3,4-2.3c3,0,5.5,1.1,7.3,2.1l2.7-5c-3.8-2.1-6.8-2.7-10.3-2.7 c-5.9,0-10.1,3.1-10.2,8.1c-0.1,4.6,2.7,6.9,8,7.7l1.3,0.2c3.3,0.5,5,0.9,5,2.5c0,1.6-1.7,2.4-4,2.4c-3.6,0-6.3-1.3-8.2-2.7l-3,4.9 c2.8,2.1,6.9,3.2,11.2,3.2c5.4,0,10.7-2.5,10.7-8.6c0-4.2-3.1-6.5-8-7.3l-1.1-0.2C104.6,81.7,102.2,81.3,102.2,79.7 M139.4,85 c0,4.4-2.9,7.4-7.1,7.4c-4.1,0-7.1-3-7.1-7.4c0-4.4,2.9-7.4,7.1-7.4C136.4,77.7,139.4,80.7,139.4,85 M145.7,85 c0-7.6-5.6-13.2-13.4-13.2c-7.8,0-13.4,5.6-13.4,13.2c0,7.6,5.6,13.2,13.4,13.2C140.1,98.2,145.7,92.6,145.7,85"
  })));
};
OhsoLogo.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
OhsoLogo.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = OhsoLogo;